function SkeletonCard({rows = 3}) {
  return (
    <s-section>
      <s-stack direction="block" gap="base">
        <div style={{height: 14, width: '35%', background: '#e3e3e3', borderRadius: 4}} />
        {Array.from({length: rows}, (_, index) => (
          <div key={index} style={{height: 24, width: index === rows - 1 ? '65%' : '100%', background: '#f1f1f1', borderRadius: 4}} />
        ))}
      </s-stack>
    </s-section>
  );
}

export default function ProductPageSkeleton() {
  return (
    <div role="status" aria-label="Loading product">
      <div aria-hidden="true">
        <s-query-container>
          <s-grid gridTemplateColumns="@container (inline-size > 800px) 2fr 1fr, 1fr" gap="base" alignItems="start">
            <s-stack direction="block" gap="base">
              <SkeletonCard rows={4} />
              <SkeletonCard rows={2} />
              <SkeletonCard rows={3} />
            </s-stack>
            <s-stack direction="block" gap="base">
              <SkeletonCard rows={2} />
              <SkeletonCard rows={3} />
            </s-stack>
          </s-grid>
        </s-query-container>
      </div>
    </div>
  );
}
